import React from "react";
const MycircleRed = ({ selected }) => {
  return (
    <>
      <div className="record-main-no">
        <div
          style={{
            background: "red",
            borderRadius: "50%",
            width: "2em",
            height: "2em",
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <span>{selected}</span>
        </div>
      </div>
    </>
  );
};

export default MycircleRed;
